import axios from 'axios';
import config from 'src/app/config';
import {
    Tournament,
    TournamentLeaderbordsItem,
    TournamentRulesItem,
    TournamentsBanner,
    TournametsListItem,
    FreeBet,
} from '../types';
//
const protocol = config.api.includes('localhost') ? 'http' : 'https';

export const api = axios.create({
    baseURL: process.env.LOCAL
        ? `${protocol}://localhost:9000/api/common`
        : `${protocol}://${config.api}/api/common`,
});

const apiBets = axios.create({
    baseURL: process.env.LOCAL
        ? `${protocol}://localhost:9000/api`
        : `${protocol}://${config.api}/api`,
});

const apiTranslates = axios.create({
    baseURL: `${protocol}://${config.api}/api`,
});
///public/api/translates/{projectID}/latest/en?v={i18nVersion}
export const getTranslates = ({
    projectId,
    version,
    locale,
    key,
}: {
    projectId: string;
    version: string | null;
    locale: string;
    key?: string;
}): Promise<{ data: { [key: string]: string } }> =>
    apiTranslates.get(
        `/translates/${projectId}/latest/${locale}${key ? `/${key}` : ''}${
            version ? `?v=${version}` : ''
        }`,
    );

export const getUnfulfilledBets = ({
    headers,
    ...params
}: {
    headers: any;
    roundId: string;
    theme: string;
}) => apiBets.post(`/bets/unfulfilled`, params, { headers });

export const getAllBets = ({ headers }: { headers: any }) =>
    api.get(`/bets/all`, { headers });

export const getMyBets = ({
    headers,
    gameId,
}: {
    headers: any;
    gameId: string;
}) => api.get(`/bets/my?gameId=${gameId}`, { headers });

export const getFreeBets = ({
    headers,
    gameId,
}: {
    headers: any;
    gameId: string;
}): Promise<{ data: FreeBet[] }> =>
    api.get(`/freebets/all?gameId=${gameId}`, { headers });

export const getTopBets = ({ headers }: { headers: any }) =>
    api.get(`/bets/top`, { headers });

export const getProfile = (params: {
    cid: string;
    token: string;
    gameId?: string;
    currency?: string;
    visitorId?: string;
}) => api.post(`/profile`, params);

export const getSettings = (params: {
    cid: string;
    domain?: string;
    subPartnerId?: string;
    gameId?: string;
}) => apiBets.post(`/game/settings`, params);

export const getPlayerStatistics = ({ headers, ...params }: any) =>
    api.post('/player/statistics', params, { headers });

export const getPlayerStatisticsWheel = ({ headers, ...params }: any) =>
    api.post('/player/statistics/wheel', params, { headers });

export const getLimit = ({ headers, params }: { headers: any; params?: {} }) =>
    api.get(`/limits`, { headers, params });

export const getRates = ({ headers }: { headers: any }) =>
    api.get(`/rates`, { headers });

export const putPlayerName = ({
    headers,
    name,
}: {
    headers: any;
    name: string;
}) => api.put(`/player`, { nickname: name }, { headers });

export const getBetInfo = ({
    headers,
    betId,
}: {
    headers: any;
    betId: string;
}) => api.get(`/bets/${betId}`, { headers });

export const getTournaments = ({
    headers,
    params,
}: {
    headers: any;
    params: { sub_partner_id?: string; gameId: string };
}): Promise<{ data: Tournament[] }> =>
    api.get(
        `/tournaments/my?gameId=${params.gameId}${
            params.sub_partner_id
                ? `&subPartnerId=${params.sub_partner_id}`
                : ''
        }`,
        { headers },
    );

export const getTournamentLeaderbords = ({
    headers,
    tournamentId,
}: {
    headers: any;
    tournamentId: string;
}): Promise<{ data: { list: TournamentLeaderbordsItem[] } }> =>
    api.get(`/tournaments/${tournamentId}/my`, { headers });

export const getTournamentWinners = ({
    headers,
    tournamentId,
}: {
    headers: any;
    tournamentId: string;
}): Promise<{ data: { list: TournamentLeaderbordsItem[] } }> =>
    api.get(`/tournaments/${tournamentId}`, { headers });

export const getTournamentsRules = ({
    url = 'https://landingnews.dev.turbogames.work',
    tournamentId,
}: {
    url: string;
    tournamentId: string;
}): Promise<{ data: { data: [TournamentRulesItem] } }> =>
    // }) =>
    axios.get(
        `${url}/api/tournaments?filters[tournamentId][$eq]=${tournamentId}&locale=all&populate=*`,
    );

export const getTournamentsList = ({
    url = 'https://landingnews.dev.turbogames.work',
}: {
    url: string;
}): Promise<{
    data: {
        data: [TournametsListItem];
    };
}> => axios.get(`${url}/api/tournaments-lists?populate=*`);

export const getStream = ({
    headers,
    gameId,
    currentDate,
    cid,
    subPartnerId,
}: {
    headers: any;
    gameId: string;
    currentDate: string;
    cid: string;
    subPartnerId: string;
}): Promise<{
    data: {
        id: string; //"a2aa9e4b-cad9-42a7-8173-1be4067d0c69",
        gameId: string; //'aero'
        startedAt: string; //'2023-09-13T12:00:00.000Z'
        finishedAt: string; //'2023-09-13T13:00:00.000Z'
        playerType: 'youtube' | 'iframe';
        url: string; //'https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley';
    };
}> =>
    api.get(
        `/game/streams?gameId=${gameId}&currentDate=${currentDate}&cid=${cid}&subPartnerId=${subPartnerId}`,
        {
            headers,
        },
    );

export const getVersion = ({
    gameId,
    headers,
}: {
    gameId: string;
    headers: any;
}) => api.get(`/version/${gameId}`, { headers });

export default api;
